// libraries and utilities
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { apiPost, BASE_URL, retrieveToken } from "../../store/api";
import { showModal } from "../modal/modal.actions";
import { UserRoleSaveResponse } from "./types";

import * as userRoleActions from "./userRole.actions";

export function* createRole(
  action: ReturnType<typeof userRoleActions.createRoleAsync.request>
) {
  try {
    let errors: ErrorResponse = {
      name: '',
      message: '',
      code: 422,
      status: 422,
      data: []
    };

    if (!action.payload.NAME) {
      errors.data?.push({
        field: "NAME",
        message: "Nama peran wajib diisi"
      })
    }

    if (errors.data && errors.data.length > 0) {
      yield put(userRoleActions.createRoleAsync.failure(errors));
      return;
    }

    const token: string = yield retrieveToken();
    const url = BASE_URL + 'roles';
    const payload = {
      ...action.payload,
      PERMISSIONS: action.payload.PERMISSION_DETAIL
    }
    const result: Response = yield call(apiPost, url, token, payload);

    if (result.status === 201) {
      const parsed: UserRoleSaveResponse = yield call(result.json.bind(result));
      yield put(showModal('Data berhasil disimpan', 'Silahkan tutup dialog ini untuk melanjutkan kegiatan Anda.'))
      yield put(userRoleActions.createRoleAsync.success(parsed));
      return; 
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(userRoleActions.createRoleAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      name: 'Internal server error',
      message: 'Internal server error',
      code: 500,
      status: 500
    }
    yield put(userRoleActions.createRoleAsync.failure(parsed));
  }
}

export default function* userRoleSagaCreateRole() {
  yield takeEvery(userRoleActions.createRoleAsync.request, createRole);
}
